/* OSMODI commerce behaviours: header, rails, tabs, facets, gallery, sticky buy bar. */

(function () {
  const lock = (on) => document.body.classList.toggle('oc-locked', on);

  /* ---------------- Header mega menu + mobile drawer ---------------- */

  function initHeader(scope) {
    const header = scope.querySelector('[data-oc-header]');
    if (!header || header.dataset.ready === 'true') return;
    header.dataset.ready = 'true';

    const items = Array.from(header.querySelectorAll('[data-oc-nav-item]'));

    const closeAll = (except) => {
      items.forEach((item) => {
        if (item === except) return;
        item.dataset.open = 'false';
        const trigger = item.querySelector('[data-oc-nav-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-oc-nav-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const open = item.dataset.open === 'true';
        closeAll(item);
        item.dataset.open = open ? 'false' : 'true';
        trigger.setAttribute('aria-expanded', String(!open));
      });

      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 1000px)').matches) {
          closeAll(item);
          item.dataset.open = 'true';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      item.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 1000px)').matches) {
          item.dataset.open = 'false';
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeAll(null);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(null);
    });

    const drawer = scope.querySelector('[data-oc-drawer]');
    const openBtn = header.querySelector('[data-oc-drawer-open]');
    if (drawer && openBtn) {
      const setOpen = (on) => {
        drawer.dataset.open = String(on);
        openBtn.setAttribute('aria-expanded', String(on));
        lock(on);
      };
      openBtn.addEventListener('click', () => setOpen(drawer.dataset.open !== 'true'));
      drawer.querySelectorAll('[data-oc-drawer-close]').forEach((node) => {
        node.addEventListener('click', () => setOpen(false));
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.dataset.open === 'true') setOpen(false);
      });
    }

    const searchbar = header.querySelector('[data-oc-searchbar]');
    const searchToggle = header.querySelector('[data-oc-search-toggle]');
    if (searchbar && searchToggle) {
      searchToggle.addEventListener('click', () => {
        const open = searchbar.dataset.open !== 'true';
        searchbar.dataset.open = String(open);
        searchToggle.setAttribute('aria-expanded', String(open));
        if (open) {
          const input = searchbar.querySelector('[data-oc-search-input]');
          if (input) window.setTimeout(() => input.focus(), 30);
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && searchbar.dataset.open === 'true') {
          searchbar.dataset.open = 'false';
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    const onScroll = () => {
      header.dataset.stuck = String(window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const cartCount = header.querySelector('[data-oc-cart-count]');
    if (cartCount) {
      const paint = (count) => {
        cartCount.textContent = count > 99 ? '99+' : String(count);
        cartCount.hidden = !count;
      };
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => cart && paint(cart.item_count))
        .catch(() => {});
      document.addEventListener('cart:updated', (event) => {
        const count = event.detail && event.detail.cart && event.detail.cart.item_count;
        if (typeof count === 'number') paint(count);
      });
    }
  }

  /* ---------------- Product rails ---------------- */

  function initRails(scope) {
    scope.querySelectorAll('[data-oc-rail]').forEach((rail) => {
      if (rail.dataset.ready === 'true') return;
      rail.dataset.ready = 'true';

      const track = rail.querySelector('[data-oc-rail-track]');
      const prev = rail.querySelector('[data-oc-rail-prev]');
      const next = rail.querySelector('[data-oc-rail-next]');
      if (!track) return;

      const step = () => Math.max(track.clientWidth * 0.8, 240);

      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------- Tabs ---------------- */

  function initTabs(scope) {
    scope.querySelectorAll('[data-oc-tabs]').forEach((group) => {
      if (group.dataset.ready === 'true') return;
      group.dataset.ready = 'true';

      const tabs = Array.from(group.querySelectorAll('[data-oc-tab]'));
      const panels = Array.from(group.querySelectorAll('[data-oc-tabpanel]'));

      const select = (id) => {
        tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.ocTab === id)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.ocTabpanel !== id;
        });
      };

      tabs.forEach((tab) => tab.addEventListener('click', () => select(tab.dataset.ocTab)));
      if (tabs.length) select(tabs[0].dataset.ocTab);
    });
  }

  /* ---------------- Facet drawer ---------------- */

  function initFacets(scope) {
    const facets = scope.querySelector('[data-oc-facets]');
    const openBtn = scope.querySelector('[data-oc-facets-open]');
    if (!facets || !openBtn || facets.dataset.ready === 'true') return;
    facets.dataset.ready = 'true';

    const setOpen = (on) => {
      if (on) {
        facets.dataset.drawer = 'true';
      } else {
        delete facets.dataset.drawer;
      }
      openBtn.setAttribute('aria-expanded', String(on));
      lock(on);
    };

    openBtn.addEventListener('click', () => setOpen(facets.dataset.drawer !== 'true'));
    facets.querySelectorAll('[data-oc-facets-close]').forEach((node) =>
      node.addEventListener('click', () => setOpen(false))
    );
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && facets.dataset.drawer === 'true') setOpen(false);
    });
    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 1000px)').matches && facets.dataset.drawer === 'true') setOpen(false);
    });

  }

  /* ---------------- Collection sorting ---------------- */

  function initSort(scope) {
    scope.querySelectorAll('[data-oc-sort]').forEach((sort) => {
      if (sort.dataset.ready === 'true') return;
      sort.dataset.ready = 'true';
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------- Collection filter dialog ---------------- */

  function initCollectionFilters(scope) {
    scope.querySelectorAll('details.oc-filters').forEach((filters) => {
      if (filters.dataset.ready === 'true') return;
      filters.dataset.ready = 'true';

      const summary = filters.querySelector(':scope > summary');
      const panel = filters.querySelector('[data-oc-filters-panel]');
      const closeButtons = Array.from(filters.querySelectorAll('[data-oc-filters-close]'));
      const mobile = () => window.matchMedia('(max-width: 620px)').matches;
      let restoreFocus = false;

      const focusable = () => Array.from(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((node) => !node.hidden && node.getClientRects().length > 0);

      const sync = () => {
        const modalOpen = filters.open && mobile();
        if (modalOpen) {
          panel.setAttribute('aria-modal', 'true');
          lock(true);
          window.setTimeout(() => {
            const nodes = focusable();
            (nodes[0] || panel).focus();
          }, 0);
        } else {
          panel.removeAttribute('aria-modal');
          lock(false);
          if (!filters.open && restoreFocus && summary) summary.focus();
          restoreFocus = false;
        }
      };

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          restoreFocus = true;
          filters.open = false;
        });
      });

      filters.addEventListener('toggle', sync);
      document.addEventListener('keydown', (event) => {
        if (!filters.open || !mobile()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          restoreFocus = true;
          filters.open = false;
          return;
        }
        if (event.key !== 'Tab') return;
        const nodes = focusable();
        if (!nodes.length) {
          event.preventDefault();
          panel.focus();
          return;
        }
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------- Product gallery ---------------- */

  function initGallery(scope) {
    scope.querySelectorAll('[data-oc-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready === 'true') return;
      gallery.dataset.ready = 'true';

      const main = gallery.querySelector('[data-oc-gallery-main]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-oc-gallery-thumb]'));
      if (!main || thumbs.length < 2) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach((other) => other.setAttribute('aria-current', String(other === thumb)));
          main.src = thumb.dataset.full || thumb.querySelector('img').src;
          main.srcset = '';
          main.alt = thumb.dataset.alt || main.alt;
        });
      });
    });
  }

  /* ---------------- Sticky buy bar ---------------- */

  function initStickyBuy(scope) {
    const bar = scope.querySelector('[data-oc-stickybuy]');
    const anchor = scope.querySelector('[data-oc-buy-anchor]');
    if (!bar || !anchor || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        bar.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }),
      { rootMargin: '0px' }
    );
    observer.observe(anchor);
  }

  /* ---------------- Quick add ---------------- */

  function initQuickAdd(scope) {
    scope.querySelectorAll('[data-oc-quickadd]').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';

      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const id = button.dataset.variantId;
        if (!id) return;
        const original = button.innerHTML;
        button.disabled = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('add failed');
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          button.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>';
          window.setTimeout(() => {
            button.innerHTML = original;
            button.disabled = false;
          }, 1600);
        } catch (error) {
          button.innerHTML = original;
          button.disabled = false;
          window.location.href = button.dataset.productUrl || '/cart';
        }
      });
    });
  }

  function initAll(scope) {
    const root = scope || document;
    initHeader(root);
    initRails(root);
    initTabs(root);
    initFacets(root);
    initSort(root);
    initCollectionFilters(root);
    initGallery(root);
    initStickyBuy(root);
    initQuickAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target || document));
})();
